/**
 * Edge path generation (SVG)
 * --------------------------
 * - Parent/Child edges: solid connectors between parent bottom -> child top
 * - Spouse edges: dotted line between node centers (toggleable by prop)
 *
 * Cycle handling:
 * - If an edge points to a node at the same-or-higher level, we render a "wrap"
 *   path that goes upward first, then over, then down. Nodes are never duplicated.
 */

export function buildParentChildPath(fromPos, toPos, verticalGap = 90) {
  if (!fromPos || !toPos) return null;

  const x1 = fromPos.cx;
  const y1 = fromPos.bottom;
  const x2 = toPos.cx;
  const y2 = toPos.top;

  const goingDown = fromPos.depth < toPos.depth;
  const midY = goingDown ? (y1 + y2) / 2 : Math.min(y1, y2) - Math.max(30, verticalGap / 2);

  // Simple elbow connector: down/up -> across -> down
  return `M ${x1} ${y1} V ${midY} H ${x2} V ${y2}`;
}

export function buildSpousePath(aPos, bPos) {
  if (!aPos || !bPos) return null;
  return `M ${aPos.cx} ${aPos.cy} L ${bPos.cx} ${bPos.cy}`;
}
